module.exports = __webpack_public_path__ + "static/media/12.b776da9c.jpg";